import axios from 'axios'
import { hasTrackingConsent } from './cookieConsent'

function normalizeRoutePath(routePath) {
  const candidate = String(routePath || '').trim()
  if (!candidate) return '/'
  const normalized = candidate.split('?', 1)[0].split('#', 1)[0].trim()
  return normalized || '/'
}

function buildVisitPayload(input) {
  if (typeof input === 'string') {
    return {
      page_name: input || document.title || 'Unknown',
      route_path: normalizeRoutePath(window.location.hash?.replace(/^#/, '') || window.location.pathname),
      page_url: window.location.href,
    }
  }

  const routePath = normalizeRoutePath(input?.routePath || window.location.hash?.replace(/^#/, '') || window.location.pathname)

  return {
    page_name: String(input?.pageName || document.title || routePath || 'Unknown').trim(),
    route_path: routePath,
    page_url: window.location.href,
  }
}

export function trackPageVisit(input) {
  if (!hasTrackingConsent()) {
    return Promise.resolve(null)
  }

  const endpoint = '/api/v1/monitoring/track-visit/'
  const visitData = buildVisitPayload(input)

  return axios.post(endpoint, visitData).catch(error => {
    console.error('Error tracking anonymous visit:', error)
    return null
  })
}

export function getVisitorInfo() {
  if (!hasTrackingConsent()) {
    return null
  }

  return {
    route_path: normalizeRoutePath(window.location.hash?.replace(/^#/, '') || window.location.pathname),
    page_url: window.location.href,
  }
}

export function clearTrackingSession() {
  return null
}

window.trackPageVisit = trackPageVisit
window.getVisitorInfo = getVisitorInfo
